(function () {
  'use strict';

  var PANEL_TRANSITION_MS = 380;

  function slugify(text, index) {
    var slug = String(text || '')
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');

    return slug || 'policy-section-' + (index + 1);
  }

  function isHeading(node) {
    return node && node.nodeType === 1 && /^H[2-4]$/.test(node.tagName);
  }

  function promoteSubheadings(rte) {
    rte.querySelectorAll('h3, h4').forEach(function (heading) {
      var h2 = document.createElement('h2');
      h2.innerHTML = heading.innerHTML;
      heading.replaceWith(h2);
    });
  }

  function unwrapDivTree(root) {
    var guard = 0;
    var changed = true;

    while (changed && guard++ < 40) {
      changed = false;
      var divs = Array.from(root.querySelectorAll('div'));

      for (var i = divs.length - 1; i >= 0; i--) {
        var div = divs[i];
        if (!div.parentNode || !root.contains(div)) continue;
        if (div.querySelector('ul, ol') && !div.querySelector('h2, h3, h4')) continue;

        var parent = div.parentNode;
        var shouldUnwrap =
          parent === root ||
          !!div.querySelector('h2, h3, h4') ||
          (parent.tagName === 'DIV' && div.querySelector('h2, h3, h4'));

        if (!shouldUnwrap) continue;

        while (div.firstChild) {
          parent.insertBefore(div.firstChild, div);
        }

        div.remove();
        changed = true;
      }
    }
  }

  function normalizeRteStructure(rte) {
    normalizeRichTextContent(rte);
    unwrapDivTree(rte);
    promoteSubheadings(rte);
    unwrapDivTree(rte);
    normalizeRichTextContent(rte);
  }

  function blockStartsWithCheckmark(node) {
    if (!node || node.nodeType !== 1) return false;
    if (/^H[1-6]$/.test(node.tagName) || node.tagName === 'UL' || node.tagName === 'OL') {
      return false;
    }

    var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
    return /^[√✓☑]/u.test(text);
  }

  function stripCheckmarkPrefixHtml(html) {
    return String(html || '')
      .replace(/^(\s|&nbsp;|<br\s*\/?>)*(<span[^>]*>\s*)?[√✓☑]\s*/iu, '')
      .replace(/^(\s|&nbsp;|<br\s*\/?>)*/iu, '')
      .trim();
  }

  function groupCheckmarkBlocks(container) {
    var index = 0;

    while (index < container.childNodes.length) {
      var node = container.childNodes[index];

      if (!blockStartsWithCheckmark(node)) {
        index++;
        continue;
      }

      var list = document.createElement('ul');
      list.className = 'c27-policy-checklist';

      while (index < container.childNodes.length && blockStartsWithCheckmark(container.childNodes[index])) {
        var block = container.childNodes[index];
        var item = document.createElement('li');
        item.innerHTML = stripCheckmarkPrefixHtml(block.innerHTML);
        list.appendChild(item);
        block.remove();
      }

      container.insertBefore(list, container.childNodes[index] || null);
      index++;
    }
  }

  function groupCheckmarkBlocksDeep(root) {
    groupCheckmarkBlocks(root);

    Array.from(root.querySelectorAll('div, p')).forEach(function (container) {
      if (container.closest('ul, ol, li')) return;
      if (container.querySelector('ul.c27-policy-checklist')) return;

      var childBlocks = Array.from(container.children).filter(blockStartsWithCheckmark);
      if (childBlocks.length > 1) {
        groupCheckmarkBlocks(container);
      }
    });
  }

  function convertAceLines(root) {
    root.querySelectorAll('div[class*="ace-line"], div[class*="heading-"]').forEach(function (div) {
      if (div.querySelector('h2, h3, h4')) return;

      var p = document.createElement('p');
      p.innerHTML = div.innerHTML;
      div.replaceWith(p);
    });
  }

  function convertCheckmarkLists(root) {
    var candidates = Array.from(root.querySelectorAll('p, div, span, li'));

    candidates.forEach(function (el) {
      if (el.closest('ul, ol') || el.classList.contains('c27-policy-checklist')) return;
      if (el.querySelector('p, div, ul, ol, li')) return;

      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      var markers = text.match(/[√✓☑]/gu);
      if (!markers || markers.length < 2) return;

      var pieces = text.split(/\s*[√✓☑]\s*/u).filter(function (part) {
        return part.trim();
      });

      if (pieces.length < 2) return;

      var intro = pieces[0].trim();
      var items = pieces.slice(1);
      var fragment = document.createDocumentFragment();

      if (intro) {
        var introParagraph = document.createElement('p');
        introParagraph.innerHTML = intro;
        fragment.appendChild(introParagraph);
      }

      var list = document.createElement('ul');
      list.className = 'c27-policy-checklist';

      items.forEach(function (itemHtml) {
        var listItem = document.createElement('li');
        listItem.innerHTML = itemHtml.trim();
        list.appendChild(listItem);
      });

      fragment.appendChild(list);
      el.replaceWith(fragment);
    });
  }

  function stripInlineFormattingNoise(root) {
    root.querySelectorAll('[class*="old-record-id"], [class*="ace-line"]').forEach(function (node) {
      node.removeAttribute('class');
    });

    root.querySelectorAll('span').forEach(function (span) {
      if (span.hasAttribute('style') || span.hasAttribute('data-mce-style')) return;
      if (span.attributes.length > 0) return;

      if (span.parentNode) {
        while (span.firstChild) {
          span.parentNode.insertBefore(span.firstChild, span);
        }
        span.remove();
      }
    });
  }

  function normalizeRichTextContent(root) {
    stripInlineFormattingNoise(root);
    convertAceLines(root);
    groupCheckmarkBlocksDeep(root);
    convertCheckmarkLists(root);
  }

  function collectNodesUntilNextHeading(heading, nextHeading) {
    var nodes = [];
    var cursor = heading.nextSibling;

    while (cursor) {
      if (cursor === nextHeading) break;
      if (isHeading(cursor)) break;
      nodes.push(cursor);
      cursor = cursor.nextSibling;
    }

    return nodes;
  }

  function buildGroups(rte) {
    var headings = Array.from(rte.children).filter(isHeading);
    if (!headings.length) {
      headings = Array.from(rte.querySelectorAll('h2, h3, h4'));
    }
    if (!headings.length) return [];

    return headings.map(function (heading, index) {
      return {
        h2: heading,
        nodes: collectNodesUntilNextHeading(heading, headings[index + 1] || null)
      };
    });
  }

  function setAccordionItemOpen(item, open) {
    var trigger = item.querySelector('[data-policy-accordion-trigger]');
    var panel = item.querySelector('[data-policy-accordion-panel]');
    if (!trigger || !panel) return;

    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    item.classList.toggle('is-open', open);
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function toggleAccordionItem(item) {
    setAccordionItemOpen(item, !item.classList.contains('is-open'));
  }

  function extractPreamble(rte, prefix) {
    var wrap = document.createElement('div');

    while (rte.firstChild) {
      var node = rte.firstChild;
      if (node.nodeType === 1 && isHeading(node)) break;
      wrap.appendChild(node);
    }

    if (!wrap.childNodes.length) return null;

    var isDates = /Last Updated:/i.test(wrap.textContent || '');
    wrap.className = prefix + (isDates ? '__dates' : '__preamble');

    return wrap;
  }

  function mountAccordionRte(rte, prefix, defaultOpen) {
    normalizeRteStructure(rte);

    var preamble = extractPreamble(rte, prefix);
    var built = buildAccordion(rte, prefix, defaultOpen);
    if (!built.accordion) {
      if (preamble) {
        if (rte.firstChild) {
          rte.insertBefore(preamble, rte.firstChild);
        } else {
          rte.appendChild(preamble);
        }
      }
      return built;
    }

    while (rte.firstChild) {
      rte.removeChild(rte.firstChild);
    }

    if (preamble) {
      normalizeRichTextContent(preamble);
      rte.appendChild(preamble);
    }

    rte.appendChild(built.accordion);
    rte.dataset.policyEnhanced = 'true';

    return built;
  }

  function buildAccordion(rte, prefix, defaultOpen) {
    var groups = buildGroups(rte);
    if (!groups.length) return { accordion: null, items: [] };

    var startOpen = defaultOpen === true;

    var accordion = document.createElement('div');
    accordion.className = prefix + '__accordion';
    accordion.setAttribute('data-policy-accordion', '');

    var items = [];

    groups.forEach(function (group, index) {
      var panelId = prefix + '-panel-' + (index + 1);
      var sectionId = group.h2.id || slugify(group.h2.textContent, index);

      var item = document.createElement('div');
      item.className = prefix + '__accordion-item';
      item.id = sectionId;
      item.setAttribute('data-policy-accordion-item', '');

      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = prefix + '__accordion-trigger';
      trigger.setAttribute('data-policy-accordion-trigger', '');
      trigger.setAttribute('aria-expanded', startOpen ? 'true' : 'false');
      trigger.setAttribute('aria-controls', panelId);

      var titleSpan = document.createElement('span');
      titleSpan.className = prefix + '__section-title';
      titleSpan.textContent = group.h2.textContent.trim();

      var icon = document.createElement('span');
      icon.className = prefix + '__accordion-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '+';

      trigger.appendChild(titleSpan);
      trigger.appendChild(icon);

      var panel = document.createElement('div');
      panel.className = prefix + '__accordion-panel';
      panel.id = panelId;
      panel.setAttribute('data-policy-accordion-panel', '');
      panel.setAttribute('aria-hidden', startOpen ? 'false' : 'true');

      var panelInner = document.createElement('div');
      panelInner.className = prefix + '__accordion-panel-inner';

      group.nodes.forEach(function (node) {
        panelInner.appendChild(node);
      });

      normalizeRichTextContent(panelInner);

      panel.appendChild(panelInner);
      group.h2.remove();

      if (startOpen) {
        item.classList.add('is-open');
      }

      trigger.addEventListener('click', function () {
        toggleAccordionItem(item);
      });

      item.appendChild(trigger);
      item.appendChild(panel);
      accordion.appendChild(item);
      items.push(item);
    });

    return { accordion: accordion, items: items };
  }

  function enhancePcRte(root) {
    var rte = root.querySelector('.c27-policy-pc__rte');
    if (!rte || rte.dataset.policyEnhanced === 'true') {
      return rte ? Array.from(rte.querySelectorAll('[data-policy-accordion-item]')) : [];
    }

    var built = mountAccordionRte(rte, 'c27-policy-pc', root.dataset.pcDefaultExpanded === 'true');
    if (!built.accordion) return [];

    return built.items;
  }

  function scrollItemIntoView(item) {
    var trigger = item.querySelector('[data-policy-accordion-trigger]');
    if (!trigger) return;
    trigger.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function openItemAndScroll(item) {
    if (!item.classList.contains('is-open')) {
      setAccordionItemOpen(item, true);
      window.setTimeout(function () {
        scrollItemIntoView(item);
      }, PANEL_TRANSITION_MS);
      return;
    }

    scrollItemIntoView(item);
  }

  function initPcToc(root, items) {
    if (root.dataset.showToc === 'false') return;

    var tocNav = root.querySelector('[data-c27-policy-toc]');
    var tocList = root.querySelector('[data-c27-policy-toc-list]');
    if (!tocNav || !tocList || !items.length) {
      if (tocNav) tocNav.hidden = true;
      return;
    }

    tocList.innerHTML = '';

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-policy-accordion-trigger]');
      if (!trigger) return;

      var title = trigger.querySelector('.c27-policy-pc__section-title');
      if (!title) return;

      var li = document.createElement('li');
      li.className = 'c27-policy-pc__toc-item';

      var link = document.createElement('a');
      link.className = 'c27-policy-pc__toc-link';
      link.href = '#' + item.id;
      link.textContent = title.textContent.trim();

      link.addEventListener('click', function (event) {
        event.preventDefault();
        openItemAndScroll(item);
      });

      li.appendChild(link);
      tocList.appendChild(li);
    });

    tocNav.hidden = tocList.children.length === 0;
  }

  function enhanceMobileRte(root) {
    var rte = root.querySelector('.c27-policy-m__rte');
    if (!rte || rte.dataset.policyEnhanced === 'true') return;

    var built = mountAccordionRte(rte, 'c27-policy-m', root.dataset.mobileDefaultExpanded === 'true');
    if (!built.accordion) return;
  }

  function initPolicyPage(root) {
    if (!root || root.dataset.c27PolicyInit === 'true') return;
    root.dataset.c27PolicyInit = 'true';

    var items = enhancePcRte(root);
    initPcToc(root, items);
    enhanceMobileRte(root);
  }

  function boot() {
    document.querySelectorAll('.c27-policy-page').forEach(initPolicyPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
